import api from './api';

const receivablesService = {
  // Listar todos os recebimentos esperados
  getAll: (params = {}) => {
    return api.get('/receivables', { params });
  },

  // Obter recebimentos de um projeto
  getByProject: (projectId) => {
    return api.get(`/receivables/project/${projectId}`);
  },

  // Listar parcelas atrasadas
  getOverdue: (params = {}) => {
    return api.get('/receivables/overdue', { params });
  },

  // Obter estatísticas
  getStats: () => {
    return api.get('/receivables/stats');
  },

  // Registrar recebimento
  receive: (receivableId, data) => {
    return api.post(`/receivables/${receivableId}/receive`, data);
  },

  // Reprogramar ou cancelar parcela
  reschedule: (receivableId, data) => {
    return api.put(`/receivables/${receivableId}/reschedule`, data);
  }
};

export default receivablesService;